<template>
  <div id="app">
    <appHeader />
    <router-view/>
    <appFooter />
  </div>
</template>

<script>
import appFooter from './components/appFooter.vue';

export default {
  name: 'App',
  components: {
    appFooter
  }
}
</script>

<style scoped>
/* 可以添加全局样式 */
</style> 